import { render, staticRenderFns } from "./DistributionTenantModal.vue?vue&type=template&id=0839397c&"
import script from "./DistributionTenantModal.vue?vue&type=script&lang=js&"
export * from "./DistributionTenantModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports